import { VipPlanContextSchemaData } from '../schema'
import { trackEvent } from './helper'

export const view_vip_plan = () =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'view_vip_plan',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })

export const select_vip = (props: { vipPlan: VipPlanContextSchemaData }) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'select_vip',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const subscribe_vip = (props: { vipPlan: VipPlanContextSchemaData }) =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'subscribe_vip',
      format: 'jsonschema',
      version: '1-0-0',
    },
    ...props,
  })

export const restore_vip = () =>
  trackEvent({
    schema: {
      vendor: 'space.yay',
      name: 'restore_vip',
      format: 'jsonschema',
      version: '1-0-0',
    },
  })
